import { createApi } from '@core/fetch'

export default {
  already: createApi('/p/wedding/index.php/Admin/APIFinderActivity/index'),

  record: createApi('/p/wedding/index.php/Admin/APIFinderActivityApply/list'),

  point: createApi(
    '/p/wedding/index.php/Admin/APIFinderActivity/activityPoint'
  ),

  apply: createApi.post(
    '/p/wedding/index.php/Admin/APIFinderActivityApply/apply'
  ),

  example_list: createApi(
    '/p/wedding/index.php/Admin/APIFinderActivityExample/list'
  ),

  example_detail: createApi(
    '/p/wedding/index.php/Admin/APIFinderActivityExample/detail'
  ),

  view: createApi('/p/wedding/index.php/Admin/APIFinderActivityApply/detail'),

  payPoint: createApi('/p/wedding/index.php/Admin/APIFinderActivity/payPoint'),

  pay: createApi.post('/p/wedding/index.php/Admin/APIFinderActivity/pay'),

  charge_list: createApi('/p/wedding/index.php/Admin/APIFinderActivityWallet'),

  check_in: createApi.post(
    '/p/wedding/index.php/Admin/APIFinderActivitySignUp/check_in'
  ),

  enroll: createApi('/p/wedding/index.php/Admin/APIFinderActivitySignUp/list'),

  pay_view: createApi(
    '/p/wedding/index.php/Admin/APIFinderActivity/payViewPhone'
  ),

  remark: createApi.post(
    '/p/wedding/index.php/Admin/APIFinderActivitySignUp/remark'
  ),

  getWallet: createApi(
    '/p/wedding/index.php/Admin/APIFinderActivityWallet/wallet'
  ),
  getEnrollList: createApi(
    '/p/wedding/index.php/admin/APIMerchantCustomer/finder_activity_apply'
  ),
  createFinderActivity: createApi.post(
    '/p/wedding/index.php/admin/APIWcdActivity/activity_finder'
  ),
  updateImg: createApi.post(
    '/p/wedding/index.php/admin/APIFinderActivity/update_img'
  ),
  operateRecord: createApi.post(
    '/p/wedding/index.php/admin/APIMerchantCustomer/operate_record'
  )
}
